(function () {
  'use strict';

  var DIAMETER_OPTIONS = [
    { value: 17, variantId: 44039447576886, price: 50 },
    { value: 18, variantId: 44039447609654, price: 100 },
    { value: 19, variantId: 44039447642422, price: 125 },
    { value: 20, variantId: 44039447675190, price: 150 },
    { value: 21, variantId: 44039447707958, price: 175 },
    { value: 22, variantId: 44039447740726, price: 200 },
  ];
  var WIDTH_VALUES = [7.5, 8.0, 8.5, 9.0, 9.5, 10.0, 10.5, 11.0];
  var WIDTH_SURCHARGES = [
    { min: 11.0, variantId: 44039451836726, price: 35 },
    { min: 10.5, variantId: 44039451803958, price: 20 },
  ];
  var OFFSET_MIN = -10, OFFSET_MAX = 55;
  var STUD_VALUES = ['5x100', '5x108', '5x112', '5x114.3', '5x120'];
  var HUB_VALUES = [54.1, 56.1, 57.1, 60.1, 64.1, 66.6, 70.5, 72.6];
  var FINISH_OPTIONS = [
    { id: 'powder', label: 'Powder Coating', price: 0, variantId: 44039266140470, colourKey: 'powder', desc: 'Widest colour range, durable everyday finish' },
    { id: 'brushed', label: 'Brushed Finish', price: 60, variantId: 44035323101494, colourKey: 'brushed', desc: 'Machined & brushed raw aluminium look' },
    { id: 'chrome', label: 'Chrome Finish', price: 125, variantId: 44035323134262, colourKey: 'chrome', desc: 'Mirror chrome plating' },
  ];
  var CAP_OPTIONS = [
    { id: 'standard', label: 'Standard SWF Cap', sub: 'Included', price: 0, variantId: 44058602570038 },
    { id: 'billet', label: 'Billet SWF Cap', sub: '+$40 / wheel', price: 40, variantId: 44058599063862 },
  ];
  var COATING_OPTIONS = [
    { id: 'none', label: 'None', sub: 'Included', price: 0, variantId: null },
    { id: 'face', label: 'Face Only', sub: '+$50 / wheel', price: 50, variantId: 54547494469942 },
    { id: 'full', label: 'Whole Rim', sub: '+$75 / wheel', price: 75, variantId: 54547494502710 },
  ];
  var DELIVERY_OPTIONS = [
    { id: 'standard', label: 'Standard', sub: '13–16 weeks · Included', price: 0, variantId: null, buildTime: '13–16 week build time' },
    { id: 'express12', label: 'Express', sub: '8–12 weeks · +$125', price: 125, variantId: 44523670470966, buildTime: '8–12 week build time' },
    { id: 'priority8', label: 'Priority', sub: '4–8 weeks · +$500', price: 500, variantId: 44480951714102, buildTime: '4–8 week build time' },
  ];

  function money(n) { return '$' + Math.round(n).toLocaleString('en-AU'); }
  function roundHalf(n) { return Math.round(n * 2) / 2; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function widthPriceFor(w) { for (var i = 0; i < WIDTH_SURCHARGES.length; i++) { if (w >= WIDTH_SURCHARGES[i].min) return WIDTH_SURCHARGES[i]; } return { price: 0, variantId: null }; }

  function init(root) {
    var cfgEl = document.getElementById(root.dataset.configId);
    var coloursEl = document.getElementById(root.dataset.coloursId);
    var config = cfgEl ? JSON.parse(cfgEl.textContent) : {};
    var colours = coloursEl ? JSON.parse(coloursEl.textContent) : { powder: [], brushed: [], chrome: [] };
    var vehicles = [];

    var state = {
      mode: 'guided',
      vehicleId: null, vehicleQuery: '',
      compareOpen: false, manualWidth: 8.0, manualOffset: 35,
      diameter: 19, widthFront: 9.0, offset: 30,
      staggered: false, widthRear: 9.0, offsetRear: 30, fitmentAxle: 'front',
      aftermarket: false, studPattern: '5x114.3', hubBore: 57.1,
      finishTier: 'powder', color: null,
      cap: 'standard', coatingOption: 'none', deliveryOption: 'standard',
      notesOpen: false, notes: '',
      vehicleCardOpen: true,
      adding: false, addError: '',
    };

    fetch(config.vehiclesUrl).then(function (r) { return r.json(); }).then(function (data) {
      vehicles = data.vehicles || [];
      render();
    }).catch(function () { render(); });

    function findVehicle() { for (var i = 0; i < vehicles.length; i++) { if (vehicles[i].id === state.vehicleId) return vehicles[i]; } return null; }

    function computeFitment() {
      var vehicle = findVehicle();
      var currentSpec = null;
      if (vehicle) currentSpec = { width: vehicle.width, offset: vehicle.offset };
      else if (state.compareOpen) currentSpec = { width: state.manualWidth, offset: state.manualOffset };
      if (!currentSpec) return { hasData: false };

      var useRear = state.staggered && state.fitmentAxle === 'rear';
      var buildWidth = useRear ? state.widthRear : state.widthFront;
      var buildOffset = useRear ? state.offsetRear : state.offset;

      var backspacing = function (w, o) { return (w * 25.4) / 2 + o; };
      var curBS = backspacing(currentSpec.width, currentSpec.offset);
      var newBS = backspacing(buildWidth, buildOffset);
      var curWidthMM = currentSpec.width * 25.4;
      var newWidthMM = buildWidth * 25.4;

      var curInner = -curBS, curOuter = curWidthMM - curBS;
      var newInner = -newBS, newOuter = newWidthMM - newBS;

      var chassisDelta = Math.round(newBS - curBS);
      var faceDelta = Math.round((newWidthMM - curWidthMM) - (newBS - curBS));

      var faceLabel = faceDelta === 0 ? 'Flush with stock' : (faceDelta > 0 ? '+' + faceDelta + 'mm further out' : Math.abs(faceDelta) + 'mm tucked in');
      var chassisLabel = chassisDelta === 0 ? 'Same as stock' : (chassisDelta > 0 ? '+' + chassisDelta + 'mm closer to chassis' : Math.abs(chassisDelta) + 'mm further from chassis');

      // Percentage-based scaling so the diagram always fills and centers
      // itself inside whatever the real container width is (a fixed pixel
      // track previously assumed a ~300px box, leaving a wide real container
      // mostly empty on one side).
      var marginPct = 4;
      var minPos = Math.min(curInner, newInner);
      var maxPos = Math.max(curOuter, newOuter);
      var range = Math.max(maxPos - minPos, 10);
      var usablePct = 100 - marginPct * 2;
      var scale = usablePct / range;
      var toPct = function (pos) { return marginPct + (pos - minPos) * scale; };

      var curBar = { left: toPct(curInner), width: toPct(curOuter) - toPct(curInner) };
      var newBar = { left: toPct(newInner), width: toPct(newOuter) - toPct(newInner) };
      var hubX = toPct(0);

      return {
        hasData: true,
        curBar: curBar, newBar: newBar, hubX: hubX,
        faceLabel: faceLabel, chassisLabel: chassisLabel,
      };
    }

    function computePricing() {
      var diamOpt = DIAMETER_OPTIONS.filter(function (d) { return d.value === state.diameter; })[0] || DIAMETER_OPTIONS[0];
      var finishOpt = FINISH_OPTIONS.filter(function (f) { return f.id === state.finishTier; })[0];
      var capOpt = CAP_OPTIONS.filter(function (c) { return c.id === state.cap; })[0];
      var coatingOpt = COATING_OPTIONS.filter(function (c) { return c.id === state.coatingOption; })[0];
      var deliveryOpt = DELIVERY_OPTIONS.filter(function (d) { return d.id === state.deliveryOption; })[0];

      var wFront = widthPriceFor(state.widthFront);
      var wRear = state.staggered ? widthPriceFor(state.widthRear) : wFront;

      var sharedPerWheel = config.basePrice + diamOpt.price + finishOpt.price + capOpt.price + coatingOpt.price;
      var perWheelFront = sharedPerWheel + wFront.price;
      var perWheelRear = sharedPerWheel + wRear.price;
      // Delivery is a one-time order fee, not a per-wheel cost — kept out of
      // perWheel/×4 math and added once into the order total below.
      var total4 = (perWheelFront * 2) + (perWheelRear * 2) + deliveryOpt.price;

      var lines = [{ label: 'Base wheel', value: money(config.basePrice) }, { label: 'Diameter (' + state.diameter + '″)', value: '+' + money(diamOpt.price) }];
      if (state.staggered) {
        lines.push({ label: 'Front width (' + state.widthFront + 'J)', value: wFront.price ? '+' + money(wFront.price) : 'Included' });
        lines.push({ label: 'Rear width (' + state.widthRear + 'J)', value: wRear.price ? '+' + money(wRear.price) : 'Included' });
      } else if (wFront.price > 0) {
        lines.push({ label: 'Width (' + state.widthFront + 'J)', value: '+' + money(wFront.price) });
      }
      if (finishOpt.price > 0) lines.push({ label: finishOpt.label, value: '+' + money(finishOpt.price) });
      if (capOpt.price > 0) lines.push({ label: capOpt.label, value: '+' + money(capOpt.price) });
      if (coatingOpt.price > 0) lines.push({ label: 'Ceramic coating (' + coatingOpt.label + ')', value: '+' + money(coatingOpt.price) });
      if (deliveryOpt.price > 0) lines.push({ label: deliveryOpt.label + ' delivery', value: '+' + money(deliveryOpt.price) });

      return {
        diamOpt: diamOpt, wFront: wFront, wRear: wRear, finishOpt: finishOpt, capOpt: capOpt, coatingOpt: coatingOpt, deliveryOpt: deliveryOpt,
        perWheelFront: perWheelFront, perWheelRear: perWheelRear, total4: total4, lines: lines, staggered: state.staggered,
      };
    }

    function patchFitmentDiagram() {
      var curEl = root.querySelector('#sw-fs-diagram-cur');
      var newEl = root.querySelector('#sw-fs-diagram-new');
      if (!curEl || !newEl) return;
      var fitment = computeFitment();
      if (!fitment.hasData) return;
      curEl.style.left = fitment.curBar.left + '%';
      curEl.style.width = fitment.curBar.width + '%';
      newEl.style.left = fitment.newBar.left + '%';
      newEl.style.width = fitment.newBar.width + '%';
      var hubEl = root.querySelector('#sw-fs-diagram-hub');
      if (hubEl) hubEl.style.left = fitment.hubX + '%';
      var innerGuideEl = root.querySelector('#sw-fs-diagram-guide-inner');
      if (innerGuideEl) innerGuideEl.style.left = fitment.curBar.left + '%';
      var outerGuideEl = root.querySelector('#sw-fs-diagram-guide-outer');
      if (outerGuideEl) outerGuideEl.style.left = (fitment.curBar.left + fitment.curBar.width) + '%';
      var faceEl = root.querySelector('#sw-fs-stat-face');
      if (faceEl) faceEl.textContent = fitment.faceLabel;
      var overallEl = root.querySelector('#sw-fs-stat-overall');
      if (overallEl) overallEl.textContent = fitment.chassisLabel;
    }

    function patchOffsetUI() {
      // Lightweight DOM patch used while dragging an offset slider — avoids
      // a full re-render (which would recreate the range input mid-drag and
      // make it feel jerky/unresponsive).
      var labelEl = root.querySelector('#sw-fs-offset-label');
      if (labelEl) labelEl.textContent = 'ET' + state.offset;
      var fillEl = root.querySelector('#sw-fs-slider-fill');
      if (fillEl) fillEl.style.width = (((state.offset - OFFSET_MIN) / (OFFSET_MAX - OFFSET_MIN)) * 100) + '%';
      patchFitmentDiagram();
    }

    function patchManualOffsetUI() {
      var labelEl = root.querySelector('#sw-fs-manual-offset-label');
      if (labelEl) labelEl.textContent = 'ET' + state.manualOffset;
      var fillEl = root.querySelector('#sw-fs-manual-offset-fill');
      if (fillEl) fillEl.style.width = (((state.manualOffset - OFFSET_MIN) / (OFFSET_MAX - OFFSET_MIN)) * 100) + '%';
      patchFitmentDiagram();
    }

    function patchOffsetRearUI() {
      var labelEl = root.querySelector('#sw-fs-offset-rear-label');
      if (labelEl) labelEl.textContent = 'ET' + state.offsetRear;
      var fillEl = root.querySelector('#sw-fs-slider-fill-rear');
      if (fillEl) fillEl.style.width = (((state.offsetRear - OFFSET_MIN) / (OFFSET_MAX - OFFSET_MIN)) * 100) + '%';
      patchFitmentDiagram();
    }

    function chip(label, sub, active, action, value) {
      return '<div class="sw-fs__chip" data-active="' + active + '" data-action="' + action + '" data-value="' + esc(value) + '">' +
        '<div class="sw-fs__chip-main">' + esc(label) + '</div>' +
        (sub ? '<div class="sw-fs__chip-sub">' + esc(sub) + '</div>' : '') + '</div>';
    }

    function tierCard(opt, active, colourKey) {
      var swatch = colourKey === 'powder' ? '#1c1c1e' : (colourKey === 'brushed' ? 'linear-gradient(135deg,#c9c9cc,#8f8f92)' : 'linear-gradient(135deg,#eef2f4,#9fb2ba)');
      return '<div class="sw-fs__tier-card" data-active="' + active + '" data-action="set-finish" data-value="' + opt.id + '">' +
        '<div class="sw-fs__tier-swatch" style="background:' + swatch + '">​</div>' +
        '<div class="sw-fs__tier-label">' + esc(opt.label) + '</div>' +
        '<div class="sw-fs__tier-desc">' + esc(opt.desc) + '</div>' +
        '<div class="sw-fs__tier-price">' + (opt.price ? '+' + money(opt.price) + ' / wheel' : 'Included') + '</div></div>';
    }

    function optCard(opt, active, action) {
      return '<div class="sw-fs__tier-card" data-active="' + active + '" data-action="' + action + '" data-value="' + opt.id + '" style="flex:1">' +
        '<div class="sw-fs__tier-label">' + esc(opt.label) + '</div>' +
        '<div class="sw-fs__tier-desc">' + esc(opt.sub) + '</div></div>';
    }

    function render() {
      var vehicle = findVehicle();
      var hasVehicle = !!vehicle;
      var isGuided = state.mode === 'guided';
      var isKnow = state.mode === 'know';
      var pricing = computePricing();
      var fitment = computeFitment();

      var html = '';

      // Header
      html += '<div class="sw-fs__head">' +
        '<div><div class="sw-fs__eyebrow">Custom Build</div><h2 class="sw-fs__title">Build your forged set</h2>' +
        '<div class="sw-fs__sub">' + (isGuided ? "Search your car and pick your spec — we'll show exactly how it compares to stock and what it costs, before you order." : 'Type your exact width, offset, stud pattern and hub bore. Add your vehicle if you want a stock fitment comparison.') + '</div></div>' +
        '<div class="sw-fs__modes">' +
        '<button type="button" class="sw-fs__mode-btn" data-active="' + isGuided + '" data-action="set-mode" data-value="guided">Guided</button>' +
        '<button type="button" class="sw-fs__mode-btn" data-active="' + isKnow + '" data-action="set-mode" data-value="know">I know my specs</button>' +
        '</div></div>';

      html += '<div class="sw-fs__grid"><div class="sw-fs__col">';

      // Vehicle card
      html += '<div class="sw-fs__card">' +
        '<div class="sw-fs__card-head" data-action="toggle-vehicle-card"><span class="sw-fs__dot"></span><span class="sw-fs__card-label">' + (isGuided ? 'Your vehicle' : 'Your vehicle (optional)') + '</span></div>';
      if (state.vehicleCardOpen) {
        if (!hasVehicle) {
          html += '<div class="sw-fs__search">' +
            '<input type="text" class="sw-fs__search-input" id="sw-fs-vq" placeholder="Search your vehicle — e.g. Golf GTI, WRX, C63..." value="' + esc(state.vehicleQuery) + '">';
          var q = state.vehicleQuery.trim().toLowerCase();
          if (q.length > 0) {
            var matches = vehicles.filter(function (v) { return (v.label + ' ' + v.sub).toLowerCase().indexOf(q) !== -1; }).slice(0, 5);
            if (matches.length) {
              html += '<div class="sw-fs__suggestions">' + matches.map(function (v) {
                return '<div class="sw-fs__suggestion" data-action="pick-vehicle" data-value="' + v.id + '"><div class="sw-fs__suggestion-label">' + esc(v.label) + '</div><div class="sw-fs__suggestion-sub">' + esc(v.sub) + '</div></div>';
              }).join('') + '</div>';
            }
          }
          html += '<div class="sw-fs__searchmeta">Searching our list of supported fitments &middot; <button type="button" class="sw-fs__link-btn" data-action="toggle-compare">' + (state.compareOpen ? 'hide manual comparison' : "can't find your car? compare manually") + '</button></div>';
          html += '</div>';
          if (state.compareOpen) {
            var manualFillPct = ((state.manualOffset - OFFSET_MIN) / (OFFSET_MAX - OFFSET_MIN)) * 100;
            html += '<div style="margin-top:16px;padding-top:16px;border-top:1px solid #e5e5e8;">' +
              '<div class="sw-fs__hint" style="text-transform:uppercase;font-weight:700;">Current width</div>' +
              '<div class="sw-fs__chips" style="margin-bottom:16px;">' + WIDTH_VALUES.map(function (w) { return chip(w + 'J', null, state.manualWidth === w, 'set-manual-width', w); }).join('') + '</div>' +
              '<div style="display:flex;align-items:baseline;justify-content:space-between;"><div class="sw-fs__hint" style="text-transform:uppercase;font-weight:700;margin:0;">Current offset (ET)</div><div style="font-size:15px;font-weight:700;" id="sw-fs-manual-offset-label">ET' + state.manualOffset + '</div></div>' +
              '<div class="sw-fs__slider-wrap">' +
                '<div class="sw-fs__slider-fill" id="sw-fs-manual-offset-fill" style="width:' + manualFillPct + '%;">​</div>' +
                '<input type="range" class="sw-fs__slider" id="sw-fs-manual-offset-range" min="' + OFFSET_MIN + '" max="' + OFFSET_MAX + '" step="1" value="' + state.manualOffset + '">' +
              '</div>' +
              '<div style="display:flex;justify-content:space-between;font-size:11px;color:#adadb1;"><span>ET' + OFFSET_MIN + '</span><span>ET' + OFFSET_MAX + '</span></div>' +
            '</div>';
          }
        } else {
          html += '<div class="sw-fs__vehicle-card">' +
            '<div><div class="sw-fs__vehicle-name">' + esc(vehicle.label) + ' <span>&middot; ' + esc(vehicle.sub) + '</span></div>' +
            '<div class="sw-fs__vehicle-stock">Stock: ' + vehicle.diameter + '″ &middot; ' + vehicle.width + 'J &middot; ET' + vehicle.offset + ' &middot; ' + esc(vehicle.stud.replace('x', '×')) + ' &middot; ' + vehicle.hub + 'mm bore</div></div>' +
            '<button type="button" class="sw-fs__link-btn" data-action="clear-vehicle">Change</button></div>';
        }
      }
      html += '</div>';

      // Build card
      html += '<div class="sw-fs__card"><div class="sw-fs__row">' +
        '<div class="sw-fs__card-head"><span class="sw-fs__dot"></span><span class="sw-fs__card-label">Build your wheels</span></div>';

      // Diameter
      html += '<div><div class="sw-fs__field-label">Diameter</div>';
      if (isGuided) html += '<div class="sw-fs__hint">Bigger looks more aggressive but rides firmer.</div>';
      html += '<div class="sw-fs__chips">' + DIAMETER_OPTIONS.map(function (d) {
        return chip(d.value + '″', '+' + money(d.price), state.diameter === d.value, 'set-diameter', d.value);
      }).join('') + '</div></div>';

      // Fitment: square vs staggered
      html += '<div><div class="sw-fs__field-label">Fitment</div>' +
        '<div class="sw-fs__modes" style="width:fit-content;margin-bottom:8px;">' +
        '<button type="button" class="sw-fs__mode-btn" data-active="' + !state.staggered + '" data-action="set-staggered" data-value="false">Square</button>' +
        '<button type="button" class="sw-fs__mode-btn" data-active="' + state.staggered + '" data-action="set-staggered" data-value="true">Staggered</button>' +
        '</div><div class="sw-fs__hint">Staggered runs a different width &amp; offset on the rear axle to the front &mdash; common on RWD performance cars. Square keeps front and rear identical.</div></div>';

      // Width
      html += '<div><div class="sw-fs__field-label">' + (state.staggered ? 'Front Width' : 'Width') + '</div>';
      if (isGuided) {
        html += '<div class="sw-fs__chips">' + WIDTH_VALUES.map(function (w) {
          var p = widthPriceFor(w).price;
          return chip(w + 'J', p ? '+' + money(p) : 'Included', state.widthFront === w, 'set-width', w);
        }).join('') + '</div>';
      } else {
        var wSur = widthPriceFor(state.widthFront);
        html += '<div style="display:flex;align-items:center;gap:12px;"><input type="number" step="0.25" class="sw-fs__text-input" id="sw-fs-width-text" value="' + state.widthFront + '">' +
          '<span style="font-size:13px;color:#6b6b70;">inches wide &middot; ' + (wSur.price ? '+' + money(wSur.price) + ' surcharge' : 'included in base price') + '</span></div>';
      }
      html += '</div>';

      if (state.staggered) {
        html += '<div><div class="sw-fs__field-label">Rear Width</div>';
        if (isGuided) {
          html += '<div class="sw-fs__chips">' + WIDTH_VALUES.map(function (w) {
            var p = widthPriceFor(w).price;
            return chip(w + 'J', p ? '+' + money(p) : 'Included', state.widthRear === w, 'set-width-rear', w);
          }).join('') + '</div>';
        } else {
          var wSurR = widthPriceFor(state.widthRear);
          html += '<div style="display:flex;align-items:center;gap:12px;"><input type="number" step="0.25" class="sw-fs__text-input" id="sw-fs-width-rear-text" value="' + state.widthRear + '">' +
            '<span style="font-size:13px;color:#6b6b70;">inches wide &middot; ' + (wSurR.price ? '+' + money(wSurR.price) + ' surcharge' : 'included in base price') + '</span></div>';
        }
        html += '</div>';
      }

      // Offset
      html += '<div><div style="display:flex;align-items:baseline;justify-content:space-between;"><div class="sw-fs__field-label">' + (state.staggered ? 'Front Offset (ET)' : 'Offset (ET)') + '</div>';
      if (isGuided) html += '<div style="font-size:19px;font-weight:700;" id="sw-fs-offset-label">ET' + state.offset + '</div>';
      html += '</div>';
      if (isGuided) {
        html += '<div class="sw-fs__hint">Controls how far the wheel face sits in or out from the guard.</div>';
        var recLeft = 0, recWidth = 0;
        if (hasVehicle) { recLeft = ((vehicle.recMin - OFFSET_MIN) / (OFFSET_MAX - OFFSET_MIN)) * 100; recWidth = ((vehicle.recMax - vehicle.recMin) / (OFFSET_MAX - OFFSET_MIN)) * 100; }
        var fillPct = ((state.offset - OFFSET_MIN) / (OFFSET_MAX - OFFSET_MIN)) * 100;
        html += '<div class="sw-fs__slider-wrap">' +
          (hasVehicle ? '<div class="sw-fs__slider-rec" style="left:' + recLeft + '%;width:' + recWidth + '%;">​</div>' : '') +
          '<div class="sw-fs__slider-fill" id="sw-fs-slider-fill" style="width:' + fillPct + '%;">​</div>' +
          '<input type="range" class="sw-fs__slider" id="sw-fs-offset-range" min="' + OFFSET_MIN + '" max="' + OFFSET_MAX + '" step="1" value="' + state.offset + '"></div>' +
          '<div style="display:flex;justify-content:space-between;font-size:11px;color:#adadb1;"><span>ET' + OFFSET_MIN + '</span><span>ET' + OFFSET_MAX + '</span></div>';
      } else {
        html += '<div style="display:flex;align-items:center;gap:12px;margin-top:8px;"><input type="number" step="1" class="sw-fs__text-input" id="sw-fs-offset-text" value="' + state.offset + '"><span style="font-size:13px;color:#6b6b70;">mm (ET) &middot; no extra cost</span></div>';
      }
      html += '</div>';

      if (state.staggered) {
        html += '<div><div style="display:flex;align-items:baseline;justify-content:space-between;"><div class="sw-fs__field-label">Rear Offset (ET)</div>';
        if (isGuided) html += '<div style="font-size:19px;font-weight:700;" id="sw-fs-offset-rear-label">ET' + state.offsetRear + '</div>';
        html += '</div>';
        if (isGuided) {
          var fillPctR = ((state.offsetRear - OFFSET_MIN) / (OFFSET_MAX - OFFSET_MIN)) * 100;
          html += '<div class="sw-fs__slider-wrap">' +
            '<div class="sw-fs__slider-fill" id="sw-fs-slider-fill-rear" style="width:' + fillPctR + '%;">​</div>' +
            '<input type="range" class="sw-fs__slider" id="sw-fs-offset-rear-range" min="' + OFFSET_MIN + '" max="' + OFFSET_MAX + '" step="1" value="' + state.offsetRear + '"></div>' +
            '<div style="display:flex;justify-content:space-between;font-size:11px;color:#adadb1;"><span>ET' + OFFSET_MIN + '</span><span>ET' + OFFSET_MAX + '</span></div>';
        } else {
          html += '<div style="display:flex;align-items:center;gap:12px;margin-top:8px;"><input type="number" step="1" class="sw-fs__text-input" id="sw-fs-offset-rear-text" value="' + state.offsetRear + '"><span style="font-size:13px;color:#6b6b70;">mm (ET) &middot; no extra cost</span></div>';
        }
        html += '</div>';
      }

      // Stud / hub
      html += '<div><div class="sw-fs__field-label">Stud Pattern &amp; Hub Bore</div>';
      if (isKnow) {
        html += '<div class="sw-fs__pair">' +
          '<div><div class="sw-fs__hint" style="margin:0 0 6px;">Stud pattern</div><input type="text" class="sw-fs__text-input" id="sw-fs-stud-text" value="' + esc(state.studPattern) + '" placeholder="e.g. 5x114.3" style="width:140px;"></div>' +
          '<div><div class="sw-fs__hint" style="margin:0 0 6px;">Hub bore (mm)</div><input type="number" step="0.1" class="sw-fs__text-input" id="sw-fs-hub-text" value="' + state.hubBore + '" placeholder="e.g. 57.1"></div></div>';
      } else {
        var showLocked = hasVehicle && !state.aftermarket;
        var showEditable = !hasVehicle || state.aftermarket;
        if (showLocked) {
          html += '<div class="sw-fs__lockpill"><strong>' + esc(state.studPattern.replace('x', '×')) + ' &middot; ' + state.hubBore + 'mm bore</strong>&nbsp;&mdash; matched to your ' + esc(vehicle.label) + '</div>';
        }
        if (hasVehicle) {
          html += '<button type="button" class="sw-fs__link-btn" data-action="toggle-aftermarket" style="font-size:12.5px;">' + (state.aftermarket ? '− Hide manual entry' : 'Using an aftermarket setup? Click here to enter your data manually') + '</button>';
        }
        if (showEditable) {
          html += '<div style="margin-top:12px;"><div class="sw-fs__hint" style="text-transform:uppercase;font-weight:700;">Stud pattern</div>' +
            '<div class="sw-fs__chips" style="margin-bottom:12px;">' + STUD_VALUES.map(function (st) { return chip(st.replace('x', '×'), null, state.studPattern === st, 'set-stud', st); }).join('') + '</div>' +
            '<div class="sw-fs__hint" style="text-transform:uppercase;font-weight:700;">Hub bore</div>' +
            '<div class="sw-fs__chips">' + HUB_VALUES.map(function (h) { return chip(h + 'mm', null, state.hubBore === h, 'set-hub', h); }).join('') + '</div></div>';
        }
      }
      html += '</div>';

      // Finish
      html += '<div><div class="sw-fs__field-label">Finish</div><div class="sw-fs__tier-grid">' +
        FINISH_OPTIONS.map(function (f) { return tierCard(f, state.finishTier === f.id, f.colourKey); }).join('') + '</div>';
      var activeFinish = FINISH_OPTIONS.filter(function (f) { return f.id === state.finishTier; })[0];
      var swatches = colours[activeFinish.colourKey] || [];
      if (swatches.length) {
        html += '<div class="sw-fs__swatch-grid">' + swatches.map(function (sw, i) {
          var active = state.color === sw.label || (state.color === null && i === 0);
          var img = sw.image ? 'background-image:url(' + sw.image + ')' : '';
          return '<button type="button" class="sw-fs__swatch-item" data-active="' + active + '" data-action="set-colour" data-value="' + esc(sw.label) + '">' +
            '<div class="sw-fs__swatch-img" style="' + img + '"><span class="sw-fs__swatch-noimg"' + (sw.image ? ' style="display:none"' : '') + '>no photo</span></div>' +
            '<div class="sw-fs__swatch-label">' + esc(sw.label) + '</div></button>';
        }).join('') + '</div>';
      } else {
        html += '<div class="sw-fs__hint" style="margin-top:12px;">No colours added yet for this finish — add variants to the "' + esc(activeFinish.label) + ' Colours" product in Shopify admin.</div>';
      }
      html += '</div>';

      // Cap
      html += '<div><div class="sw-fs__field-label">Centre Cap</div><div style="display:flex;gap:12px;">' +
        CAP_OPTIONS.map(function (c) { return optCard(c, state.cap === c.id, 'set-cap'); }).join('') + '</div></div>';

      // Coating
      html += '<div><div class="sw-fs__field-label">Ceramic Clear Coat</div><div class="sw-fs__hint" style="margin-top:0;">Guards the finish against brake dust, salt &amp; UV fade</div>' +
        '<div style="display:flex;gap:12px;">' + COATING_OPTIONS.map(function (c) { return optCard(c, state.coatingOption === c.id, 'set-coating'); }).join('') + '</div></div>';

      // Delivery
      html += '<div><div class="sw-fs__field-label">Delivery Timeframe</div><div class="sw-fs__hint" style="margin-top:0;">Need them sooner? Rush production for a fee.</div>' +
        '<div style="display:flex;gap:12px;">' + DELIVERY_OPTIONS.map(function (d) { return optCard(d, state.deliveryOption === d.id, 'set-delivery'); }).join('') + '</div></div>';

      // Notes
      html += '<div><button type="button" class="sw-fs__link-btn sw-fs__notes-toggle" data-action="toggle-notes">' + (state.notesOpen ? '− Hide custom request' : '+ Add custom request or reference notes') + '</button>';
      if (state.notesOpen) {
        html += '<textarea class="sw-fs__textarea" id="sw-fs-notes" placeholder="e.g. match this to a reference photo, specific brake caliper clearance, concave preference...">' + esc(state.notes) + '</textarea>' +
          '<div class="sw-fs__notes-note">Have reference photos? Email them to us after ordering &mdash; we\'ll confirm before production starts.</div>';
      }
      html += '</div>';

      html += '</div></div>'; // end build card, end col

      // Sidebar
      html += '<div class="sw-fs__sidebar"><div class="sw-fs__card">' +
        '<div class="sw-fs__card-head" style="cursor:default;"><span class="sw-fs__dot"></span><span class="sw-fs__card-label">Fitment preview</span></div>';
      if (!fitment.hasData) {
        html += '<div class="sw-fs__fit-empty">Search your vehicle above to see how this build compares to your stock setup.</div>';
      } else {
        if (state.staggered) {
          html += '<div class="sw-fs__modes" style="width:fit-content;margin-bottom:12px;">' +
            '<button type="button" class="sw-fs__mode-btn" data-active="' + (state.fitmentAxle !== 'rear') + '" data-action="set-fitment-axle" data-value="front">Front</button>' +
            '<button type="button" class="sw-fs__mode-btn" data-active="' + (state.fitmentAxle === 'rear') + '" data-action="set-fitment-axle" data-value="rear">Rear</button>' +
            '</div>';
        }
        html += '<div class="sw-fs__fit-legend"><div><span class="sw-fs__legend-dot" style="background:#c7c7ca;"></span>Stock</div><div><span class="sw-fs__legend-dot" style="background:#ffc82a;"></span>Your build' + (state.staggered ? ' (' + (state.fitmentAxle === 'rear' ? 'rear' : 'front') + ')' : '') + '</div></div>' +
          '<div class="sw-fs__diagram">' +
          '<div class="sw-fs__diagram-hub" id="sw-fs-diagram-hub" style="left:' + fitment.hubX + '%;">​</div>' +
          '<div class="sw-fs__diagram-guide" id="sw-fs-diagram-guide-inner" style="left:' + fitment.curBar.left + '%;">​</div>' +
          '<div class="sw-fs__diagram-guide" id="sw-fs-diagram-guide-outer" style="left:' + (fitment.curBar.left + fitment.curBar.width) + '%;">​</div>' +
          '<div class="sw-fs__diagram-tag" style="left:8px;">CHASSIS</div><div class="sw-fs__diagram-tag" style="right:8px;">FENDER</div>' +
          '<div class="sw-fs__diagram-bar" id="sw-fs-diagram-cur" style="top:26px;background:#c7c7ca;left:' + fitment.curBar.left + '%;width:' + fitment.curBar.width + '%;">​</div>' +
          '<div class="sw-fs__diagram-bar" id="sw-fs-diagram-new" style="top:44px;background:#ffc82a;left:' + fitment.newBar.left + '%;width:' + fitment.newBar.width + '%;">​</div></div>' +
          '<div class="sw-fs__stat-pair"><div class="sw-fs__stat"><div class="sw-fs__stat-label">Face position</div><div class="sw-fs__stat-val" id="sw-fs-stat-face">' + fitment.faceLabel + '</div></div>' +
          '<div class="sw-fs__stat"><div class="sw-fs__stat-label">Chassis clearance</div><div class="sw-fs__stat-val" id="sw-fs-stat-overall">' + fitment.chassisLabel + '</div></div></div>' +
          '<div class="sw-fs__explainer">Face position is how far the wheel\'s outer edge will sit compared to your stock wheel &mdash; a positive number sits further out toward the guard. Chassis clearance is how the inner edge compares &mdash; a positive number sits closer to your suspension. Both are estimates from standard offset math only. Always confirm actual clearance against your suspension, brakes and guard yourself (or ask our team) before ordering.' + (state.staggered ? ' Use the Front/Rear toggle above to see each axle\'s numbers.' : '') + '</div>';
      }
      html += '</div>';

      html += '<div class="sw-fs__price-card"><div class="sw-fs__price-title">Price summary</div>' +
        pricing.lines.map(function (l) { return '<div class="sw-fs__price-line"><span class="sw-fs__price-line-label">' + esc(l.label) + '</span><span class="sw-fs__price-line-val">' + l.value + '</span></div>'; }).join('') +
        '<div class="sw-fs__price-divider">​</div>' +
        (pricing.staggered ?
          '<div class="sw-fs__price-total-row"><span class="sw-fs__price-total-label">Per wheel (front)</span><span class="sw-fs__price-total-val" style="font-size:16px;">' + money(pricing.perWheelFront) + '</span></div>' +
          '<div class="sw-fs__price-total-row" style="margin-top:2px;"><span class="sw-fs__price-total-label">Per wheel (rear)</span><span class="sw-fs__price-total-val" style="font-size:16px;">' + money(pricing.perWheelRear) + '</span></div>'
          :
          '<div class="sw-fs__price-total-row"><span class="sw-fs__price-total-label">Per wheel</span><span class="sw-fs__price-total-val">' + money(pricing.perWheelFront) + '</span></div>'
        ) +
        '<div class="sw-fs__price-total-row" style="margin-top:2px;"><span class="sw-fs__price-total-label">Set of 4</span><span class="sw-fs__price-set-val">' + money(pricing.total4) + '</span></div>' +
        '<button type="button" class="sw-fs__atc" id="sw-fs-atc" ' + (state.adding ? 'disabled' : '') + '>' + (state.adding ? 'Adding…' : 'Add to cart — ' + money(pricing.total4)) + '</button>' +
        (state.addError ? '<div class="sw-fs__error">' + esc(state.addError) + '</div>' : '') +
        '<div class="sw-fs__buildtime">' + pricing.deliveryOpt.buildTime + ' &middot; Free fitment check by our team before production</div>' +
        '</div></div>'; // end sidebar

      html += '</div>'; // end grid

      root.innerHTML = html;
      wireInputs();
    }

    function wireInputs() {
      var vq = document.getElementById('sw-fs-vq');
      if (vq) {
        vq.addEventListener('input', function (e) { state.vehicleQuery = e.target.value; render(); document.getElementById('sw-fs-vq').focus(); document.getElementById('sw-fs-vq').selectionStart = document.getElementById('sw-fs-vq').value.length; });
      }
      var wt = document.getElementById('sw-fs-width-text');
      if (wt) wt.addEventListener('change', function (e) { state.widthFront = parseFloat(e.target.value) || 0; render(); });
      var ot = document.getElementById('sw-fs-offset-text');
      if (ot) ot.addEventListener('change', function (e) { state.offset = parseFloat(e.target.value) || 0; render(); });
      var or_ = document.getElementById('sw-fs-offset-range');
      if (or_) or_.addEventListener('input', function (e) { state.offset = Number(e.target.value); patchOffsetUI(); });
      var mor = document.getElementById('sw-fs-manual-offset-range');
      if (mor) mor.addEventListener('input', function (e) { state.manualOffset = Number(e.target.value); patchManualOffsetUI(); });
      var wrt = document.getElementById('sw-fs-width-rear-text');
      if (wrt) wrt.addEventListener('change', function (e) { state.widthRear = parseFloat(e.target.value) || 0; render(); });
      var ort = document.getElementById('sw-fs-offset-rear-text');
      if (ort) ort.addEventListener('change', function (e) { state.offsetRear = parseFloat(e.target.value) || 0; render(); });
      var orr = document.getElementById('sw-fs-offset-rear-range');
      if (orr) orr.addEventListener('input', function (e) { state.offsetRear = Number(e.target.value); patchOffsetRearUI(); });
      var st = document.getElementById('sw-fs-stud-text');
      if (st) st.addEventListener('change', function (e) { state.studPattern = e.target.value; render(); });
      var ht = document.getElementById('sw-fs-hub-text');
      if (ht) ht.addEventListener('change', function (e) { state.hubBore = parseFloat(e.target.value) || 0; render(); });
      var nt = document.getElementById('sw-fs-notes');
      if (nt) nt.addEventListener('change', function (e) { state.notes = e.target.value; });
      var atc = document.getElementById('sw-fs-atc');
      if (atc) atc.addEventListener('click', addToCart);
    }

    root.addEventListener('click', function (e) {
      var el = e.target.closest('[data-action]');
      if (!el) return;
      var action = el.dataset.action, value = el.dataset.value;
      switch (action) {
        case 'set-mode': state.mode = value; if (value === 'guided') state.vehicleCardOpen = true; break;
        case 'toggle-vehicle-card': state.vehicleCardOpen = !state.vehicleCardOpen; break;
        case 'pick-vehicle':
          state.vehicleId = value; state.vehicleQuery = ''; state.compareOpen = false; state.aftermarket = false;
          var v = vehicles.filter(function (x) { return x.id === value; })[0];
          if (v) {
            state.studPattern = v.stud; state.hubBore = v.hub;
            if (state.mode === 'guided') {
              state.diameter = Math.min(22, v.diameter + 1);
              state.widthFront = Math.min(11.0, roundHalf(v.width + 1));
              state.offset = Math.round((v.recMin + v.recMax) / 2);
            }
          }
          break;
        case 'clear-vehicle': state.vehicleId = null; state.vehicleQuery = ''; break;
        case 'toggle-compare': state.compareOpen = !state.compareOpen; break;
        case 'set-manual-width': state.manualWidth = parseFloat(value); break;
        case 'set-manual-offset': state.manualOffset = parseFloat(value); break;
        case 'set-diameter': state.diameter = parseInt(value, 10); break;
        case 'set-width': state.widthFront = parseFloat(value); break;
        case 'set-width-rear': state.widthRear = parseFloat(value); break;
        case 'set-staggered': state.staggered = (value === 'true'); break;
        case 'set-fitment-axle': state.fitmentAxle = value; break;
        case 'toggle-aftermarket': state.aftermarket = !state.aftermarket; break;
        case 'set-stud': state.studPattern = value; break;
        case 'set-hub': state.hubBore = parseFloat(value); break;
        case 'set-finish': state.finishTier = value; state.color = null; break;
        case 'set-colour': state.color = value; break;
        case 'set-cap': state.cap = value; break;
        case 'set-coating': state.coatingOption = value; break;
        case 'set-delivery': state.deliveryOption = value; break;
        case 'toggle-notes': state.notesOpen = !state.notesOpen; break;
        default: return;
      }
      render();
    });

    function addToCart() {
      var pricing = computePricing();
      var vehicle = findVehicle();
      var colourLabel = state.color || (colours[FINISH_OPTIONS.filter(function (f) { return f.id === state.finishTier; })[0].colourKey] || [])[0] && (colours[FINISH_OPTIONS.filter(function (f) { return f.id === state.finishTier; })[0].colourKey][0].label) || 'Not specified';

      var properties = {
        'Diameter': state.diameter + '"',
        'Stud Pattern': state.studPattern,
        'Hub Bore': state.hubBore + 'mm',
        'Finish': pricing.finishOpt.label,
        'Colour': colourLabel,
        'Centre Cap': pricing.capOpt.label,
        'Ceramic Coating': pricing.coatingOpt.label,
        'Delivery': pricing.deliveryOpt.label,
        'Vehicle': vehicle ? (vehicle.label + ' (' + vehicle.sub + ')') : 'Not specified',
      };
      if (pricing.staggered) {
        properties['Fitment'] = 'Staggered';
        properties['Width (Front)'] = state.widthFront + 'J';
        properties['Width (Rear)'] = state.widthRear + 'J';
        properties['Offset Front (ET)'] = String(state.offset);
        properties['Offset Rear (ET)'] = String(state.offsetRear);
      } else {
        properties['Width'] = state.widthFront + 'J';
        properties['Offset (ET)'] = String(state.offset);
      }
      if (state.notes) properties['Notes'] = state.notes;

      var items = [{ id: config.variantId, quantity: 4, properties: properties }];
      items.push({ id: pricing.diamOpt.variantId, quantity: 4 });
      if (pricing.staggered) {
        if (pricing.wFront.variantId && pricing.wFront.price > 0) items.push({ id: pricing.wFront.variantId, quantity: 2 });
        if (pricing.wRear.variantId && pricing.wRear.price > 0) items.push({ id: pricing.wRear.variantId, quantity: 2 });
      } else if (pricing.wFront.variantId && pricing.wFront.price > 0) {
        items.push({ id: pricing.wFront.variantId, quantity: 4 });
      }
      if (pricing.finishOpt.variantId && pricing.finishOpt.price > 0) items.push({ id: pricing.finishOpt.variantId, quantity: 4 });
      if (pricing.capOpt.variantId && pricing.capOpt.price > 0) items.push({ id: pricing.capOpt.variantId, quantity: 4 });
      if (pricing.coatingOpt.variantId) items.push({ id: pricing.coatingOpt.variantId, quantity: 4 });
      if (pricing.deliveryOpt.variantId) items.push({ id: pricing.deliveryOpt.variantId, quantity: 1 });

      state.adding = true; state.addError = ''; render();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items }),
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); });
        return r.json();
      }).then(function () {
        window.location.href = '/cart';
      }).catch(function (err) {
        state.adding = false; state.addError = err.message || 'Something went wrong adding this to your cart.'; render();
      });
    }

    render();
  }

  function boot() { document.querySelectorAll('[data-sw-fs]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
